import { getProductNameRenderer } from './HeaderProductName'

export {
  getProductNameRenderer,
}



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/Fields/index.js